import React, { Component } from 'react';
import { provideHooks } from 'redial';

import { getDashboard } from 'src/store/dashboard/dashboard';
import { homePageLoaded } from 'src/store/home/home';
import { setPageTitle } from 'src/store/location/location';
import { getLastSearch } from 'src/store/lastSearch/lastSearch';
import HomePage from 'src/components/HomePage/HomePage';

const hooks = {
  fetch: ({ routeEnter, dispatch, cookies, locale }) => {
    dispatch(setPageTitle(''));
    return routeEnter ? dispatch(getLastSearch({ cookies, locale })) : null;
  },
  authenticated: ({ routeEnter, dispatch }) =>
    routeEnter ? dispatch(getDashboard()) : null,
  pageLoad: ({ routeEnter, dispatch }) =>
    routeEnter ? dispatch(homePageLoaded()) : null
};

class Home extends Component {
  render() {
    return <HomePage />;
  }
}

export default provideHooks(hooks)(Home);
